import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import Navbar from './global-components/navbar-v2';
import Page_Header_Metier from './global-components/Page_Header_Metier';
import Footer from './global-components/footer-v2';
import Scrollp from './Scroll-Parallax/scrollp';
import FormulaireInscriptionEnLigne from './global-components/formulaire-inscritenligne';

const MetierDetails = () => {
  const { metierId } = useParams();
  const [metier, setMetier] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const Url = process.env.REACT_APP_URL_DEV;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [isPopupVisible, setIsPopupVisible] = useState(false); // État pour afficher ou masquer le popup

  const handleOpenPopup = () => {
    setIsPopupVisible(true);
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };
  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await axios.get(
          `${Url}/api/FicheMetierRouter/id/${metierId}/formations`,
        );
        setMetier(response.data.data);
      } catch (error) {
        console.error('Erreur lors du chargement du métier :', error);
        setError('Une erreur est survenue lors du chargement du métier.');
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [metierId]);

  if (loading) return <p className="loading">Chargement...</p>;
  if (!metier) return <p className="error">Aucun métier trouvé.</p>;
  if (!metier) return null;

  return (
    <div>
      <Navbar />
      <Page_Header_Metier />
      <div className="metier-container">
        <div className="metier-content">
          <div className="metier-description">
            <h2>Description</h2>
            <p
              dangerouslySetInnerHTML={{ __html: metier.metierDescription }}
            ></p>
          </div>
          <div className="metier-formations-card">
            <h4>Formations associées</h4>
            {Array.isArray(metier.formations) &&
            metier.formations.length > 0 ? (
              metier.formations.map((formation, index) => (
                <div key={index} className="formation-card">
                  <h4>{formation.formationNom}</h4>
                  <p>{formation.formationDescription}</p>
                  <ul>
                    <li>
                      <strong>Code:</strong> {formation.formationCode}
                    </li>
                    <li>
                      <strong>Type:</strong> {formation.formationType}
                    </li>
                    <li>
                      <strong>Durée:</strong> {formation.formationDuree}
                    </li>
                  </ul>
                  <Link
                    className="information"
                    to={`/course-details/${formation.formationCode}`}
                  >
                    En savoir plus
                  </Link>
                  {/* <button className="btn-blue">En savoir plus</button> */}
                </div>
              ))
            ) : (
              <p>Aucune formation liée à ce métier.</p>
            )}
          </div>
        </div>
      </div>
      <Footer />
      <Scrollp />

      {/* Boutons fixes */}
      <div className="fixed-buttons">
        <Link to="/Formateur">
          <button className="btn btn-primary">Devenir formateur</button>
        </Link>
        <button
          onClick={handleOpenPopup} // Affiche le popup
          className="btn btn-secondary"
        >
          Inscription en ligne
        </button>
      </div>

      {/* Popup */}
      {isPopupVisible && (
        <div className="popup-overlay ">
          <div className="popup-content ">
            {/* Formulaire d&apos;inscription */}
            <FormulaireInscriptionEnLigne />
            <button onClick={handleClosePopup} className="popup-close-button">
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MetierDetails;
